<template>
    <div>
      <div class="card m-3 tarjeta">
          <div class="card-body">
              <div class="row">
                  <div class="col-5">
                      <label for="exampleInputEmail1" class="form-label">Producto</label>
                      <select class="form-control" aria-label="Default select example" v-model="producto" @change="obtenerProducto(producto.claveTarifa)">
                          <option selected disabled>--Seleccione</option>
                          <option v-for="(producto, i) in listProducto" :key="i" :value="producto.claveProducto">
                              {{ producto.descripcion }}
                          </option>
                      </select>
                  </div>
                  <div class="col-5">
                      <label for="exampleFormControlInput1" class="form-label">Recargo producto</label>
                      <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Recargo" :disabled="ifRecargo" v-model="recargoUno">
                  </div>
                  <div class="col-1">
                      <button type="button" class="btn btn-primary mt-4" @click="buscar()">Buscar</button>
                  </div>
              </div>
              <div v-if="ifProducto" class="row m-4">
                  <div class="col 3">
                      <div class="form-check" v-for="(elemento, i) in listProdRecargo" :key="i">
                          <input class="form-check-input" :value="elemento.claveRecargo" :v-model="elementoRecargo" @change="radioEvent($event)" type="radio" name="flexRadioDefault" :id="elemento.claveRecargo">
                          <label class="form-check-label" for="flexRadioDefault1">
                              {{elemento.descripcion}}
                          </label>
                      </div>
                  </div>
                  <div class="col-9" v-if="ifEstados">
                      <div>
                          <div class="card ">
                              <div class="card-body">
                                  <h5 class="title">Estados</h5>
                                  
                                  <v-table class="table table-hover" :data="listEstados" :currentPage.sync="currentPage" :pageSize="10"
                                  @totalPagesChanged="totalPages = $event">
                                      <thead>
                                          <tr>
                                              <th scope="col">#</th>
                                              <th scope="col">Estado</th>
                                              <th scope="col">Check</th>
                                          </tr>
                                      </thead>
                                      <tbody slot="body" slot-scope="{ displayData }">
                                          <tr v-for="(result) in displayData" :key="result.guid">
                                              <!-- <th scope="row">{{ i + 1 }}</th> -->
                                              <td>{{ result.nombreEstado}}</td>
                                              <td>
                                                  <div class="form-check">
                                                      <input class="form-check-input" type="checkbox" v-bind:value="result.claveEstado" v-model="checkEstados">
                                                  </div>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </v-table>
                              </div>
                              <div class="table-responsive ml-5">
                                  <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages" />
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-9" v-if="ifCoberturas">
                      <div>
                          <div class="col-md-6 mb-2">
                              <label class="form-label">Paquete</label>
                              <select class="form-control" aria-label="Default select example" v-model="paqueteSelect" @change="changePaqueteCobertura()">
                                  <option selected disabled>--Seleccione</option>
                                  <option v-for="(paq, i) in listPaqueteSelect" :key="i" :value="paq.clavePaquete">
                                      {{ paq.descripcion }}
                                  </option>
                              </select>
                          </div>
                          <div v-if="PaqueteCobertura" class="card ">
                              <div class="card-body">
                                  <h5 class="title">Coberturas</h5>
                                  <v-table class="table table-hover" :data="listCoberturas" :currentPage.sync="currentPage" :pageSize="10"
                                  @totalPagesChanged="totalPages = $event">
                                      <thead>
                                          <tr>
                                              <th scope="col">#</th>
                                              <th scope="col">Cobertura</th>
                                              <th scope="col">Check</th>
                                          </tr>
                                      </thead>
                                      <tbody slot="body" slot-scope="{ displayData }">
                                          <tr v-for="(result) in displayData" :key="result.guid">
                                              <!-- <th scope="row">{{ i + 1 }}</th> -->
                                              <td>{{ result.descripcion}}</td>
                                              <td>
                                                  <input type="checkbox" v-bind:value="result.claveCobertura" v-model="checkCoberturas"/>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </v-table>
                              </div>
                              <div class="table-responsive ml-5">
                                  <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages" />
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-9" v-if="ifPaquetes">
                      <div>
                          <div class="card ">
                              <div class="card-body">
                                  <h5 class="title">Paquetes</h5>
                                  <table class="table table-hover">
                                      <tbody>
                                          <tr v-for="(paquete, i) in listPaquete" :key="i">
                                              <!-- <th scope="row">{{ i }}</th> -->
                                              <td>{{ paquete.descripcion}}</td>
                                              <td>
                                                  <div class="form-check">
                                                      <input class="form-check-input" type="checkbox" v-bind:value="paquete.clavePaquete" v-model="checkPaquete">
                                                  </div>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-9" v-if="ifMarca">
                      <div>
                          <div class="card ">
                              <div class="card-body">
                                  <h5 class="title">Marca</h5>
                                  <v-table class="table table-hover" :data="listMarca" :currentPage.sync="currentPage" :pageSize="10"
                                  @totalPagesChanged="totalPages = $event">
                                      <thead >
                                          <tr>
                                              <!-- <th scope="col">#</th> -->
                                              <th scope="col">Marca</th>
                                              <th scope="col">Check</th>
                                          </tr>
                                      </thead>
                                      <tbody slot="body" slot-scope="{ displayData }">
                                          <tr v-for="(result) in displayData" :key="result.guid">
                                              <!-- <th scope="row">{{ i }}</th> -->
                                              <td>{{ result.marca}}</td>
                                              <td>
                                                  <div class="form-check">
                                                      <input class="form-check-input" type="checkbox" v-bind:value="result.marca" v-model="checkMarca">
                                                  </div>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </v-table>
                              </div>
                              <div class="table-responsive ml-5">
                                  <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages" />
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-9" v-if="ifSubmarca">
                      <div>
                          <div class="col-md-6 mb-2">
                              <label class="form-label">Marca</label>
                              <select class="form-control" aria-label="Default select example" v-model="marcaSelect" @change="changeMarcaSubmarca()">
                                  <option v-for="(marca, i) in listMarcaSubM" :key="i" :value="marca.marca">
                                      {{ marca.marca }}
                                  </option>
                              </select>
                          </div>
                          <div class="card" v-if="submarcaMarca">
                              <div class="card-body">
                                  <h5 class="title">Submarca</h5>
                                  <v-table class="table table-hover" :data="listSubmarca" :currentPage.sync="currentPage" :pageSize="10"
                                  @totalPagesChanged="totalPages = $event">
                                      <thead>
                                          <tr>
                                              <th scope="col">#</th>
                                              <th scope="col">Submarca</th>
                                              <th scope="col">Check</th>
                                          </tr>
                                      </thead>
                                      <tbody slot="body" slot-scope="{ displayData }">
                                          <tr v-for="(result,) in displayData" :key="result.guid">
                                              <td>{{ result.submarca}}</td>
                                              <td>
                                                  <div class="form-check">
                                                      <input class="form-check-input" type="checkbox" v-bind:value="result.submarca" v-model="checkSubmarca">
                                                  </div>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </v-table>
                              </div>
                              <div class="table-responsive ml-5">
                                  <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages" />
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="boton mt-5 text-center">
                      <button type="button" @click="modalOpen()" class="btn btn-success">Ver Recargo</button>
                  </div>
              </div>
  
          </div>
      </div>
  
      <!-- modal -->
      <div>
          <CModal scrollable :show.sync="modal" >
          <template #header-wrapper>
              <div class="card-header text-center">
                  <h5 style="color:white">Resumen</h5>
              </div>
          </template>
          <template #footer-wrapper><span></span></template>
              <div class="card-body">
                  <div class="text-center mb-3">
                      <h5 class="title">Producto</h5>
                      <table class="table text-center table-bordered">
                          <thead>
                              <tr>
                              <th scope="col">Producto</th>
                              <th scope="col">Recargo</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>{{ nombreProducto }}</td>
                                  <td class="col-4">
                                      <input type="text" disabled class="form-control" :value="recargoUno" @change="changeinput">
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      <!-- <h5>Producto: <b>{{ nombreProducto }}</b></h5> -->
                      <br>
                  </div>
                  <div v-if="ifModal.Estado" class="mb-5">
                      <h5 class="title">Estados</h5>
                      <table class="table text-center table-bordered">
                          <thead>
                              <tr>
                              <th scope="col">Estado</th>
                              <th scope="col">Recargo</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(estado, i) in checkEstadosShow" :key="i">
                                  <td>{{ estado.recargo }}</td>
                                  <td class="col-4">
                                      <input type="number" class="form-control" v-model="estado.input" @change="changeinput()">
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div v-if="ifModal.Cobertura" class="mb-5">
                      <h5 class="title">Coberturas</h5>
                      <table class="table text-center table-bordered">
                          <thead>
                              <tr>
                              <th scope="col">Coberturas</th>
                              <th scope="col">Recargo</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(coberturas, i) in checkCoberturasShow" :key="i">
                                  <td>{{ coberturas.recargo }}</td>
                                  <td class="col-4">
                                      <input type="number" class="form-control" v-model="coberturas.input">
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div v-if="ifModal.Paquete" class="mb-5">
                      <h5 class="title">Paquetes</h5>
                      <table class="table text-center table-bordered">
                          <thead>
                              <tr>
                              <th scope="col">Paquetes</th>
                              <th scope="col">Recargo</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(paquetes, i) in checkPaqueteShow" :key="i">
                                  <td>{{ paquetes.recargo }}</td>
                                  <td class="col-4"><input type="number" class="form-control" v-model="paquetes.input"></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div v-if="ifModal.Marca" class="mb-5">
                      <h5 class="title">Marcas</h5>
                      <table class="table text-center table-bordered">
                          <thead>
                              <tr>
                              <th scope="col">Marca</th>
                              <th scope="col">Recargo</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(marca, i) in checkMarcaShow" :key="i">
                                  <td>{{ marca.recargo }}</td>
                                  <td class="col-4">
                                      <input type="number" class="form-control" v-model="marca.input">
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div v-if="ifModal.Submarca" class="mb-1">
                      <h5 class="title">Submarcas</h5>
                      <table class="table text-center table-bordered">
                          <thead>
                              <tr>
                              <th scope="col">Submarca</th>
                              <th scope="col">Recargo</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(submarca, i) in checkSubmarcaShow" :key="i">
                                  <td>{{ submarca.recargo }}</td>
                                  <td class="col-4"><input type="number" class="form-control" v-model="submarca.input"></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
              <CCardFooter  class="pt-3 pl-0 pr-0 pb-0">
                  <div class="row">
                      <div class="col-1"></div>
                      <div class="form-check col-5" align="left">
                          <input class="form-check-input" type="checkbox" id="chkCombinado" true-value="1" false-value="0" v-model="checkCombinado">
                      <label class="form-check-label" for="chkCombinado">Combinado </label>
                      </div>
                     
                
                      
                    
                  <div class="col-6" align="rigth">
                  <CButton @click="modal = false" color="secondary" class="mr-2">
                      Cerrar
                  </CButton>
                  <CButton color="primary" @click="guardarRecargos">
                      <i class="fas fa-paper-plane mr-1"></i>
                      Guardar
                  </CButton>
              </div>
               </div>
              </CCardFooter>
          
          </CModal>
      </div>
    </div>
  </template>
  
  <script>
  // import TheSidebar from '../../containers/TheSidebar.vue'
  export default {
      data(){
          return{
              checkCombinado: "0",
              currentPage: 1,
              totalPages: 0,
              tipo: "",
              estados: "",
              coberturas: "",
              paquete: "",
              marca: "",
              submarca: "",
              producto: "",
              claveTarifa: "",
              claveMarca: "",
              paqueteSelect: "",
              resultado: "",
              marcaSelect: "",
              nombreProducto: "",
              elementoRecargo: "",
              recargoUno: "",
              recargoProducto: null,
              listRecargoProducto: [],
              //Recargos list 
              checkEstados: [],
              checkEstadosShow: [],
              checkCoberturas: [],
              checkCoberturasShow: [],
              checkPaquete: [],
              checkPaqueteShow: [],
              checkMarca: [],
              checkMarcaShow: [],
              checkSubmarca: [],
              checkSubmarcaShow: [],
              // Catalogos
              listProducto: [],
              listEstados: [],
              listCoberturas: [],
              listPaquete: [],
              listPaqueteSelect: [],
              listMarca: [],
              listMarcaSubM: [],
              listSubmarca: [],
              listProdRecargo: [],
  
              ifProducto: false,
              ifEstados: false,
              ifCoberturas: false,
              ifPaquetes: false,
              ifMarca: false,
              ifRecargo: true,
              ifSubmarca: false,
              PaqueteCobertura: false,
              submarcaMarca: false,
              modal: false,
              ifModal: {
                  Estado: false,
                  Cobertura: false,
                  Paquete: false,
                  Marca: false,
                  Submarca: false,
              }
  
          }
      },
      methods: {
          modalOpen(){
              // if(this.ifRecargo == false && this.recargoUno == ""){
              //     this.$swal( "","Es necesario colocar el recargo de Producto", "info");
              //     return;
              // }
              this.modal = true;
              //Estados
              if(this.checkEstados.length > 0){
                  let arrayEstados = [];
                  this.checkEstados.forEach(clave => {
                      const data = {
                          recargo: this.listEstados.find(x => x.claveEstado == clave).nombreEstado,
                          clave: clave,
                          input: '',
                          claveRecargo: '2'
                      }
                      arrayEstados.push(data)
                  })
  
                  this.checkEstadosShow = arrayEstados
                  console.log(this.checkEstadosShow);
                  this.ifModal.Estado = true
              } else {
                  this.ifModal.Estado = false
              }
  
              //Coberturas
              if(this.checkCoberturas.length > 0){
                  let arrayCoberturas = [];
                  this.checkCoberturas.forEach(clave => {
                      const data = {
                          recargo: this.listCoberturas.find(x => x.claveCobertura == clave).descripcion,
                          clave: clave,
                          input: '',
                          claveRecargo: '3'
                      }
                      arrayCoberturas.push(data)
                  })
  
                  this.checkCoberturasShow = arrayCoberturas
                  console.log(this.checkCoberturasShow);
                  this.ifModal.Cobertura = true
              } else {
                  this.ifModal.Cobertura = false
              }
  
              //Paquetes
              if(this.checkPaquete.length > 0){
                  let arrayPaquete = [];
                  this.checkPaquete.forEach(clave => {
                      const data = {
                          recargo: this.listPaquete.find(x => x.clavePaquete == clave).descripcion,
                          clave: clave,
                          input: '',
                          claveRecargo: '4'
                      }
                      arrayPaquete.push(data)
                  })
  
                  this.checkPaqueteShow = arrayPaquete
                  console.log(this.checkPaqueteShow);
                  this.ifModal.Paquete = true
              } else {
                  this.ifModal.Paquete = false
  
              }
  
              //Marcas
              if(this.checkMarca.length > 0){
                  let arrayMarca = [];
                  this.checkMarca.forEach(clave => {
                      const data = {
                          recargo: this.listMarca.find(x => x.marca == clave).marca,
                          clave: clave,
                          input: '',
                          claveRecargo: '5'
                      }
                      arrayMarca.push(data)
                  })
  
                  this.checkMarcaShow = arrayMarca
                  console.log(this.checkMarcaShow);
                  this.ifModal.Marca = true
              } else {
                  this.ifModal.Marca = false
  
              }
  
              //Submarcas
              if(this.checkSubmarca.length > 0){
                  let arraySubmarca = [];
                  this.checkSubmarca.forEach(clave => {
                      const data = {
                          recargo: this.listSubmarca.find(x => x.submarca == clave).submarca,
                          clave: clave,
                          input: '',
                          claveRecargo: '6'
                      }
                      arraySubmarca.push(data)
                  })
  
                  this.checkSubmarcaShow = arraySubmarca
                  console.log(this.checkSubmarcaShow);
                  this.ifModal.Submarca = true
              } else {
                  this.ifModal.Submarca = false
  
              }
          },
          async buscar(){
              this.ifEstados = false,
              this.ifCoberturas = false,
              this.ifPaquetes = false,
              this.ifMarca = false,
              this.ifSubmarca = false
              this.ifProducto = false;
              if(this.producto == ""){
                  return this.$swal("", "Es necesario seleccionar un Producto", "info");
              } else {
                  this.ifProducto = true;
              }
              this.listProdRecargo = [];
              const payload = {
                  metodo: "OBTENERPRODUCTOSRECARGO",
                  data: {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa
                  },
              };
              console.log(payload);
              const res = await this.$store.dispatch("metodoPost", payload);
              if (res) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.listProdRecargo = response
                  for (let i = 0; i < this.listProdRecargo.length; i++) {
                      if(this.listProdRecargo[i].descripcion == "producto"){
                          this.listProdRecargo.splice(0,1)
                          this.ifRecargo = false;
                          return
                      } else {
                          this.ifRecargo = true;
                      }
                  }
              }
          },
          radioEvent(event){
              this.tipo = ""
              this.tipo = event.target.value
              console.log(this.resultado);
              switch (this.tipo) {
                  case "2":
                      this.catalogoEstados();
                      this.ifEstados = true,
                      this.ifCoberturas = false,
                      this.ifPaquetes = false,
                      this.ifMarca = false,
                      this.ifSubmarca = false
                      break;
                  case "3":
                      this.catalogoCoberturas();
                      this.ifEstados = false,
                      this.ifCoberturas = true,
                      this.ifPaquetes = false,
                      this.ifMarca = false,
                      this.ifSubmarca = false
                      break;
                  case "4":
                      this.catalogoPaquetes();
                      this.ifEstados = false,
                      this.ifCoberturas = false,
                      this.ifPaquetes = true,
                      this.ifMarca = false,
                      this.ifSubmarca = false
                      break;
                  case "5":
                      this.catalogoMarcas();
                      this.ifEstados = false,
                      this.ifCoberturas = false,
                      this.ifPaquetes = false,
                      this.ifMarca = true,
                      this.ifSubmarca = false
                      break;
                  case "6":
                      this.catalogoSubMarcas();    
                      this.ifEstados = false,
                      this.ifCoberturas = false,
                      this.ifPaquetes = false,
                      this.ifMarca = false,
                      this.ifSubmarca = true 
                      break;
                  default:
                      break;
              }
          },
          obtenerProducto(claveTarifa){
              this.claveTarifa = ""
              this.nombreProducto = "";
              for (let index = 0; index < this.listProducto.length; index++) {
                  if(this.producto == this.listProducto[index].claveProducto){
                      this.claveTarifa = this.listProducto[index].claveTarifa
                      this.nombreProducto = this.listProducto[index].descripcion;
                  }
              }
              console.log(this.nombreProducto);
              // this.catalogoEstados();
              // this.catalogoPaquetes();
              // this.catalogoCoberturas();
              // this.catalogoMarcas();
          },
          async catalogoProducto(){
              const payload = {
                  metodo: "OBTENERPRODUCTO",
                  data: {},
              };
              const res = await this.$store.dispatch("metodoPost", payload);
              if (res) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.listProducto = response;
              }
          },
          async catalogoEstados(){
              this.listEstados = [];
              const payload = {
                  metodo: "OBTENERESTADO",
                  data: {
                      claveProducto: this.producto
                  },
              };
              console.log(payload);
              const res = await this.$store.dispatch("metodoPost", payload);
              if (res) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.listEstados = response;
              } else {
                  return this.$swal("Sin Estados", "", "info");
              }
          },
          async catalogoPaquetes(){
              this.listPaquete = [];
              const payload = {
                  metodo: "OBTENERPAQUETES",
                  data: {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa
  
                  },
              };
              console.log(payload);
              const res = await this.$store.dispatch("metodoPost", payload);
              if (res) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.listPaquete = response;
              } else {
                  return this.$swal("Sin Paquetes", "", "info");
              }
          },       
          async catalogoCoberturas(){
              this.listPaqueteSelect = []
              const payloadPaquete = {
                  metodo: "OBTENERPAQUETES",
                  data: {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa
  
                  },
              };
              console.log(payloadPaquete);
              const paquete = await this.$store.dispatch("metodoPost", payloadPaquete);
              if (paquete) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.listPaqueteSelect = response;
              }
          },
          async catalogoMarcas(){
              this.listMarca = [];
              const payload = {
                  metodo: "OBTENERMARCAS",
                  data: {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
  
                  },
              };
              console.log(payload);
              const res = await this.$store.dispatch("metodoPost", payload);
              if (res) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.listMarca = response;
              }else {
                  return this.$swal("Sin Marcas", "", "info");
              }
          },
          async catalogoSubMarcas(){
  
              const payloadMarca = {
                  metodo: "OBTENERMARCAS",
                  data: {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
  
                  },
              };
              console.log(payloadMarca);
              const marca = await this.$store.dispatch("metodoPost", payloadMarca);
              if (marca) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.listMarcaSubM = response;
              }
  
          },
          async changePaqueteCobertura(){
              this.PaqueteCobertura = true;
                  this.listCoberturas = [];
                  const payload = {
                      metodo: "OBTENERCOBERTURAS",
                      data: {
                          claveProducto: this.producto,
                          claveTarifa: this.claveTarifa,
                          clavePaquete: this.paqueteSelect
      
                      },
                  };
                  console.log(payload);
                  const res = await this.$store.dispatch("metodoPost", payload);
                  if (res) {
                      const response = this.$store.getters.getRespuestaREST;
                      console.log(response);
                      this.listCoberturas = response;
                  } else {
                      return this.$swal("Sin Coberturas", "", "info");
                  }
          },
          async changeMarcaSubmarca(){
              this.submarcaMarca = true;
              this.listSubmarca = [];
              const payload = {
                  metodo: "OBTENERSUBMARCAS",
                  data: {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
                      claveMarca: this.marcaSelect
                  },
              };
              console.log(payload);
              const res = await this.$store.dispatch("metodoPost", payload);
              if (res) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.listSubmarca = response;
              }else {
                  return this.$swal("Sin Submarcas", "", "info");
              }
          },
          changeinput(txt){
              // this.listRecargoProducto.push(this.recargoProducto)
              // console.log(this.checkEstadosShow);
          },
          async guardarRecargos(){
              let dataSend = [];
  
              //Producto
              if( this.recargoUno != ""){
                  const item = {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
                      claveRecargo: "1",
                      porcentaje: this.recargoUno,
                      claveLlave: this.producto,
                      combinado: this.checkCombinado
                  }
                  dataSend.push(item);
              }
  
              // estedos
              this.checkEstadosShow.map(x => {
                  const item = {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
                      claveRecargo: x.claveRecargo,
                      porcentaje: x.input,
                      claveLlave: x.clave,
                      combinado: this.checkCombinado
                  }
                  dataSend.push(item);
              });
  
              // coberturas
              this.checkCoberturasShow.map(x => {
                  const item = {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
                      claveRecargo: x.claveRecargo,
                      porcentaje: x.input,
                      claveLlave: this.paqueteSelect + "-" + x.clave,
                      combinado: this.checkCombinado
                  }
  
                  dataSend.push(item);
              });
  
              // paquete
              this.checkPaqueteShow.map(x => {
                  const item = {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
                      claveRecargo: x.claveRecargo,
                      porcentaje: x.input,
                      claveLlave: x.clave,
                      combinado: this.checkCombinado
                  }
  
                  dataSend.push(item);
              });
  
              // marca
              this.checkMarcaShow.map(x => {
                  const item = {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
                      claveRecargo: x.claveRecargo,
                      porcentaje: x.input,
                      claveLlave: x.clave,
                      combinado: this.checkCombinado
                  }
  
                  dataSend.push(item);
              });
  
              // Submarca
              this.checkSubmarcaShow.map(x => {
                  const item = {
                      claveProducto: this.producto,
                      claveTarifa: this.claveTarifa,
                      claveRecargo: x.claveRecargo,
                      porcentaje: x.input,
                      claveLlave: x.clave,
                      combinado: this.checkCombinado
                  }
  
                  dataSend.push(item);
              });
                  
  
  
  
  
              
              const payload = {
                  metodo: "GUARDARRECARGOS",
                  data: dataSend
              };
              console.log(payload);
              const res = await this.$store.dispatch("metodoPost", payload);
              console.log(res);
              if (res) {
                  const response = this.$store.getters.getRespuestaREST;
                  console.log(response);
                  this.modal = false;
                  return this.$swal({
                      icon: 'success',
                      title: response + ' exitosamente.',
                  }).then((result) => {
                      if (result.isConfirmed) {
                          window.location.reload();
                      } 
                  })
              } else {
                  return this.$swal("Error al guardar el recargo", "Es necesario ingresar todos los recargos", "error");
              }
              
          },
      },
      async mounted() {
          this.catalogoProducto();
      }
  }
  </script>
  <style>
  .tarjeta{
      border-radius: 20px;
      box-shadow: 0 4px 10px rgba(178, 179, 180, 0.7);
  }
  .title{
      text-align: center;
  
  }
  .card-header {
        background-color: rgb(33, 46, 102);
    }
  </style>